if (window.Handlebars) {
    Handlebars.registerHelper('getImage', function(obj, options){
        var defaultImages = {
            'audio': '/dl/components/img/radio/placeholder-audio.png',
            'video': '/dl/components/img/radio/placeholder-video.png',
            'articolo': '/dl/components/img/radio/placeholder-articolo.png',
            'foto': '/dl/components/img/radio/placeholder-foto.png',
            'playlist': '/dl/components/img/radio/placeholder-playlist.png',
            'raiplay-generic': '/dl/components/img/imgPlaceholder.png'
        };

        var settings = {
            'key' : 'images',
            'placeholder' : 'audio',
            'isPartOf' : false
        };

        $.extend(settings, options.hash);
        settings.type && (settings.type = settings.type.split(","));

        var resp = '';
        var placeholder = defaultImages[settings.placeholder];
        if (!obj || !obj[settings.key]) return placeholder;

        var isPartOf = settings.isPartOf;


        resp = getImg(obj[settings.key]);
        if (!resp && isPartOf){
            if (typeof obj.isPartOf.images === 'undefined') return placeholder;
            resp = getImg(obj.isPartOf.images);
        }

        function getImg(obj){
            var supportedTypes = (settings.type != null) ? settings.type : ['default', 'square', 'landscape'];

            resp = null;
            for (var i= 0; i < supportedTypes.length; i++){
                var val = supportedTypes[i];
                if (obj[val] != null && String(obj[val]).length) {
                    resp = obj[val];
                    break;
                }
            }
            return resp;
        }

        function substring(s){
            return s && s.replace(/(.*?)(\/dl\/.*)/g, "$2");
        }

        return new Handlebars.SafeString(substring(resp) || placeholder);
    });
}


// WEBPACK FOOTER //
// ./../../../rairadio/template/helpers/images-helper.js